module.exports = __webpack_public_path__ + "img/e.12916094.png";